"use client"

import React from "react"
import { createPortal } from "react-dom"

import AppContext from "./AppContext"
import PartnerModal from "./impact/impact-report/PartnerModal"
import SpotlightModal from "./impact/impact-report/SpotlightModal"
import JobFiltersModal from "./jobs/JobFiltersModal"
import BioModal from "./leadership/BioModal"

const ModalContainer = () => {
  // gets context from AppContext and renders on if modal open
  const context = React.useContext(AppContext)

  if (typeof window === "undefined") {
    return null // Don't render on server
  }

  return createPortal(
    <>
      {context.bioModal.modalOpen && (
        <BioModal
          modalOpen={context.bioModal.modalOpen}
          name={context.bioModal.name}
          title={context.bioModal.title}
          bio={context.bioModal.bio}
          company={context.bioModal.company}
          linkedin={context.bioModal.linkedin}
          lightmode={context.bioModal.lightmode}
        />
      )}
      {context.impactReportPartnersModal.modalOpen && (
        <PartnerModal modalOpen={context.impactReportPartnersModal.modalOpen} />
      )}
      {context.impactReportSpotlightModal.modalOpen && (
        <SpotlightModal
          modalOpen={context.impactReportSpotlightModal.modalOpen}
        />
      )}
      {context.jobFiltersModal.modalOpen && (
        <JobFiltersModal
          modalOpen={context.jobFiltersModal.modalOpen}
          filters={context.jobFiltersModal.filters}
        />
      )}
    </>,
    document.body,
  )
}

export default ModalContainer
